import { DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalespersonCommissionReport extends Layout {
    excludabletextboxSalespersonExclude: ExcludableTextbox;
    sourceSalespersonCommission: DataSource;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxReportType: Textbox;
}
